var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.to)?_c('button',{staticClass:"primary-button"},[_vm._t("default")],2):_c('router-link',{staticClass:"primary-button",attrs:{"to":_vm.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }